var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64597 8.35403L9.64597 13.354C9.69243 13.4005 9.74758 13.4373 9.80827 13.4625C9.86897 13.4876 9.93402 13.5006 9.99972 13.5006C10.0654 13.5006 10.1305 13.4876 10.1912 13.4625C10.2519 13.4373 10.307 13.4005 10.3535 13.354C10.3999 13.3076 10.4368 13.2524 10.4619 13.1917C10.4871 13.131 10.5 13.066 10.5 13.0003C10.5 12.9346 10.4871 12.8695 10.4619 12.8088C10.4368 12.7481 10.3999 12.693 10.3535 12.6465L5.7066 8.00028L10.3535 3.35403C10.4473 3.26021 10.5 3.13296 10.5 3.00028C10.5 2.8676 10.4473 2.74035 10.3535 2.64653C10.2597 2.55271 10.1324 2.5 9.99972 2.5C9.86704 2.5 9.73979 2.55271 9.64597 2.64653L4.64597 7.64653C4.59948 7.69296 4.5626 7.74811 4.53744 7.80881C4.51228 7.86951 4.49933 7.93457 4.49933 8.00028C4.49933 8.06599 4.51228 8.13105 4.53744 8.19175C4.5626 8.25245 4.59948 8.30759 4.64597 8.35403Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/CaretLeft.3658bfb89892b6eec2b59474dd08db10.svg";
export { ForwardRef as ReactComponent };